import { graphql } from '@/gql'

export const PaginatorInfoFragment = graphql(/* GraphQL */ `
  fragment PaginatorInfoFragment on PaginatorInfo {
    currentPage
    firstItem
    lastItem
    perPage
    total
  }
`)
